import { StaticInterface } from '../../../helpers/static-interface';

export interface ITpxWaveUtils {
}

export interface IStaticTpxWaveUtils {
  new(...args: any[]): ITpxWaveUtils;
  init(): void;
}

/**
 * Wave utilities
 * @class
 */
export default class TpxWaveUtils implements StaticInterface<IStaticTpxWaveUtils, typeof TpxWaveUtils> {
  constructor(element: HTMLElement) {
    this.fixWaveInBlockGridWhenNextBlockIsPrimaryCta(element);
  }

  fixWaveInBlockGridWhenNextBlockIsPrimaryCta(element: HTMLElement) {
    const parent = element.parentElement;
    const uncle = parent?.nextElementSibling;
    if (uncle) {
      const primaryCta = uncle.querySelector('[data-component="call-to-action-block"]');
      if (primaryCta !== null) {
        element.classList.add("wave--before-primary-cta")
      }
    }
  }

  static init() {
    const waves: Element[] = [...document.querySelectorAll('[data-component="wave"]')];
    waves.forEach(wave => {
      new TpxWaveUtils(wave as HTMLElement);
    });
  }
}